export default __webpack_public_path__ + "static/media/(36).eacc2653.jpg";